export const ClassHelper = {
    translateDefaultClass(classes, t) {
        return classes.map((classItem) => ({
            ...classItem,
            name: classItem.name === 'membership.default.class.name'
                ? t('modules.form.classes.class_a')
                : (classItem.name ?? '')
        }));
    }
};
